import { render } from "./InputCheckBox.vue?vue&type=template&id=2521ba4c&scoped=true"
import script from "./InputCheckBox.vue?vue&type=script&lang=js"
export * from "./InputCheckBox.vue?vue&type=script&lang=js"

import "./InputCheckBox.vue?vue&type=style&index=0&id=2521ba4c&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2521ba4c"]])

export default __exports__